/**
 * Checks if a search query contains special characters (non-alphanumeric except spaces)
 * @param query - The search query string
 * @returns true if the query contains special characters, false otherwise
 */
export const hasSpecialCharacters = (query: string): boolean => {
  if (!query || !query.trim()) return false
  // Check if query contains any non-alphanumeric characters (excluding spaces)
  return /[^a-zA-Z0-9\s]/.test(query.trim())
}

/**
 * Determines the appropriate search operator based on the query content
 * @param query - The search query string
 * @returns An object with the appropriate search operator ($autocomplete or $q)
 */
export const getSearchOperator = (query: string) => {
  const trimmedQuery = query.trim()
  if (hasSpecialCharacters(trimmedQuery)) {
    // Use $q for queries with special characters (full-text search that handles special chars)
    return { text: { $q: trimmedQuery } }
  } else {
    // Use $autocomplete for normal queries (prefix matching)
    return { text: { $autocomplete: trimmedQuery } }
  }
}
